//------------- REACT IMPORT ---------------//
import React from "react";
//-------- BOOTSTRAP ITEMS IMPORT ---------//
import { Button, Col, Dropdown, Form, Modal, Row } from "react-bootstrap";

const CalendarModal = (props) => {
    return (
        <div>
            <Modal show={props.show} onHide={props.close} centered className="calendar_modal">
                <Modal.Header className="header_area" closeButton>
                    <Modal.Title className="title">Calendar</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="report_details_form">
                       
                        <div className="year_btns">
                            
                            <Dropdown className="btn">
                                <Dropdown.Toggle variant="none" id="dropdown-basic" className="show">
                                    Select                                   
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="list" defaultActiveKey="first">
                                    <Dropdown.Item href="javascript:;" >Jan </Dropdown.Item>
                                    <Dropdown.Item href="javascript:;" className="active">Feb</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">Mar</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">Apr </Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">May</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">Jun</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">Jul </Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">Aug</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">Sep</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">Jun</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">Oct </Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">Nov</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">Dec</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown> 

                            <Dropdown className="btn">
                                <Dropdown.Toggle variant="none" id="dropdown-basic" className="show">
                                    Select                                
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="list">
                                    <Dropdown.Item href="javascript:;" >2018 </Dropdown.Item>
                                    <Dropdown.Item href="javascript:;" className="active"> 2019</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">2020</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">2021 </Dropdown.Item>
                                    <Dropdown.Item href="javascript:;"> 2022</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;" >2023</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">2024 </Dropdown.Item>
                                    <Dropdown.Item href="javascript:;"> 2025</Dropdown.Item>
                                    <Dropdown.Item href="javascript:;">2026</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown> 

                        </div>
                      
                        <div className="btn_area">
                            <Button className="cancelBtn" type="button" onClick={props.close}>Cancel</Button>
                            <Button className="submitBtn" type="submit">Submit</Button>
                        </div>                        
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default CalendarModal;